import api from './interceptor';

const BASE_URL_V2 = 'api/v2/common';

export default {
  getAllLanguages: () => api.get(`${BASE_URL_V2}?type=language:list`),
  getTradingPartnerService: () => api.get(`${BASE_URL_V2}?type=eligibility:list`),
  getClinics: () => api.get(`${BASE_URL_V2}/clinics`),
};
